import FixaInlineMessage from "@coworker/apprestructured/src/shared/wrappers/FixaInlineMessage/FixaInlineMessage";
import { useTranslation } from "@coworker/locales";

export const AmountMaxThresholdMessage = () => {
  const { t } = useTranslation();
  return (
    <FixaInlineMessage
      title={t("exceedingThresholdString")}
      variant={"negative"}
      body={t("maximumQuantityMessageString")}
    />
  );
};
